module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui centered container"
  }, [_c('img', {
    staticClass: "ui huge centered image",
    attrs: {
      "src": require("./../assets/logo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui centered header"
  }, [_vm._v("\n    SemVue is a effort to bring\n    "), _c('a', {
    attrs: {
      "href": "https://semantic-ui.com/"
    }
  }, [_vm._v("Semantic-ui")]), _vm._v(" components to\n    "), _c('a', {
    attrs: {
      "href": "https://vuejs.org/"
    }
  }, [_vm._v("VueJs")]), _vm._v(" project.\n  ")]), _vm._v(" "), _c('h1', {
    staticClass: "ui dividing header"
  }, [_vm._v("Install")]), _vm._v(" "), _c('h5', [_vm._v("Semantic-ui has dependency of jquery, so, I assume that you already have imported jquery in your project (but I hope that you never need to use that with this components :D)")]), _vm._v(" "), _c('h3', [_vm._v("With npm")]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_c('pre', [_vm._v("\n      npm install --save semvue\n    ")])]), _vm._v(" "), _c('h3', [_vm._v("Source Download")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/guilhermewaess/SemVue/tree/master/dist/semvue"
    }
  }, [_vm._v("You can download files here")]), _vm._v(" "), _c('h4', [_vm._v("Soon as a possible on CDN")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4d7a00c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = 159
// module chunks = 1